import icon from 'vue-svgicon';

icon.register({
    'bold/delete-2': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M20.488 3.515a11.994 11.994 0 1 0 0 16.97 12.014 12.014 0 0 0 0-16.97zm-3.779 11.764a1 1 0 0 1-1.409 1.415l-3.11-3.11a.252.252 0 0 0-.354 0l-3.109 3.11a1.019 1.019 0 0 1-1.415 0 1 1 0 0 1 0-1.415l3.11-3.109a.249.249 0 0 0 0-.353l-3.11-3.11a1 1 0 0 1 1.41-1.415l3.109 3.11a.25.25 0 0 0 .354 0l3.11-3.11a1 1 0 0 1 1.414 1.415l-3.11 3.11a.25.25 0 0 0 0 .353z"/>`,
    },
});
